export default __webpack_public_path__ + "assets/pdf/FT_ZKuV.2145f33a.pdf";